import FastMarquee from "react-fast-marquee";

const ITEMS = [
    "40+ Years of Excellence",
    "Parallel Keys",
    "Lead Screws",
    "Shafts",
    "Slide Plates",
    "MS Rollers",
    "Custom Machining",
];

const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="py-6 md:py-8 border-y border-[#D9D9D9] bg-[#FAFAFA] overflow-hidden"
    >
        <FastMarquee speed={38} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={item} className="flex items-center shrink-0">
                    <span
                        className={`font-heading uppercase font-medium text-3xl md:text-5xl tracking-tight px-6 md:px-10 ${
                            i % 2 === 0 ? "text-outline" : "text-[#111111]"
                        }`}
                    >
                        {item}
                    </span>
                    <span className="w-2.5 h-2.5 md:w-3 md:h-3 bg-copper rotate-45 inline-block" />
                </span>
            ))}
        </FastMarquee>
    </div>
);

export default Marquee;
